import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';

Sentry.init({
  dsn: environment.sentryDsn,
  environment: environment.production ? 'production' : 'development',
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 0.2,
  beforeSend: (event) => {
    // scrub license keys, tokens from breadcrumbs
    if (event.breadcrumbs) {
      event.breadcrumbs.forEach(breadcrumb => {
        if (breadcrumb.message && typeof breadcrumb.message === 'string') {
          breadcrumb.message = breadcrumb.message.replace(/Bearer [A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*/g, 'Bearer [REDACTED]');
          breadcrumb.message = breadcrumb.message.replace(/BR(?:TL|EW|WP|WX|WL|PL)-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}/ig, '[REDACTED_LICENSE]');
        }
      });
    }
    return event;
  }
});

console.log('--- STARTING BOOTSTRAP ---');
bootstrapApplication(AppComponent, appConfig)
  .then(() => console.log('--- BOOTSTRAP SUCCESS ---'))
  .catch((err) => console.error('--- BOOTSTRAP ERROR ---', err));

